<template>
  <!-- Home Page -->
  <section>
    <div id="home" class="text-center page">
      <div class="overlay">
        <div class="content col-md-12">
          <h1 style="text-transform:none;font-size:75px">Your success partner</h1>
          <h3> Together, let's get IT done </h3>
          <a href="#home_more"><button type="button" class="btn btn-orange"> Get Started </button></a><br>
        </div>
      </div>
    </div>
     <a id=home_more></a>
    <home_more />
  </section>
</template>

<script>
import home_more from "./home_more" 

export default {
    components:{home_more}
}
</script>
